let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("63Pb3")).then(() => parcelRequire('3W12e'));